import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import i18n from '../i18n';

const LanguageSwitcher: React.FC = () => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    setShowDropdown(false); // Close the dropdown after selecting a language
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {/* Globe Icon Button */}
      <button 
        onClick={() => setShowDropdown(!showDropdown)} 
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1.5rem',
          color: '#fff',
        }}
      >
        <FontAwesomeIcon icon={faGlobe} />
      </button>

      {/* Dropdown Menu */}
      {showDropdown && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          backgroundColor: 'white',
          border: '1px solid #ddd',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          zIndex: 1,
          borderRadius: '4px',
          overflow: 'hidden',
        }}>
          <button onClick={() => changeLanguage('en')} style={dropdownButtonStyle}>English</button>
          <button onClick={() => changeLanguage('fi')} style={dropdownButtonStyle}>Suomi</button>
          <button onClick={() => changeLanguage('fr')} style={dropdownButtonStyle}>Français</button>
        </div>
      )}
    </div>
  );
};

// Inline styles for the dropdown buttons
const dropdownButtonStyle: React.CSSProperties = {
  padding: '10px 20px',
  width: '100%',
  textAlign: 'left',
  backgroundColor: 'white',
  border: 'none',
  cursor: 'pointer',
};

export default LanguageSwitcher;
